
import MainMenu from '../components/partials/header/main-menu';


function Header () {

    return (
        <header className="header header-5">
            <MainMenu />
        </header>
    )
}

export default Header;